import React, { useState } from "react"
import * as classNames from "./SearchResultListBlock.module.scss"
import BlockLrSearchResult from "../block-LR-search-result/BlockLrSearchResult"
import BlockSearchResult from "../block-search-result/BlockSearchResult"
import Button from "../../../blocks/button/Button"
import Section from "../../../../../core/layout/main/section/Section"
import CtxHeroSection from "../../ctx-hero-section/CtxHeroSection"
import Card from "../../../blocks/card/Card"

function SearchResultListBlock({ articles, term }) {
  const [displayedCardCount, setDisplayedCardCount] = useState(4)
  const cardsToLoad = 4
  const handleLoadMore = () => {
    setDisplayedCardCount((prevCount) => prevCount + cardsToLoad)
  }
  const allArticles = articles.Articles || []
  return (
    <>
      <CtxHeroSection
        imgSrc="https://media.paritel.fr/paritel-www-dev/assets/entete_hero_generique_875504765b.png"
        imgAlt="entête hero generique"
        classes="mb-5 pb-8"
      >
        <Card className="container card_bottom flex flex-direction-column justify-content-end align-items-center text-center pbl-6 pin-3 gap-4">
          <h1> Résultats de recherche pour : {term}</h1>
        </Card>
      </CtxHeroSection>
      <Section container>
        <>
          <BlockLrSearchResult
            article={articles}
            // term={queryTerm}
          />
          <div className={`${classNames.articleGrid}`}>
            {allArticles.slice(1, 1 + displayedCardCount).map((article, index) => (
              <BlockSearchResult
                article={article}
                handleLoadMore={handleLoadMore}
              />
            ))}
          </div>
        </>

        {allArticles.length > displayedCardCount && (
          <div className="flex justify-center align-items pt-8 pb-4">
            <Button
              onClick={handleLoadMore}
              aspect={"classique"}
              color={"primary"}
            >
              Voir plus
            </Button>
          </div>
        )}
      </Section>
    </>
  )
}
export default SearchResultListBlock
